import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Whether Move Planner is locked.
 */
export const schema = z.boolean();

export type AddMovesDisabled = z.infer<typeof schema>;

export const definition = define({
  key: 'add_moves_disabled',
  schema,
  label: 'Move Planner Activation',
  description:
    'Activate/Deactivate the move planning feature for this client. This will allow the client to create moves in our portal or API. NOTE: This switch will deactivate automatically when a client goes over their move limit. Please use the Bypass Auto-Deactivation option to override this behavior.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
